export default {
  min: {
    title:
      'Livrare la locația ta: Suma necesară pentru a atinge valoarea minimă a comenzii (Subtotal excl. costuri livrare și bacșiș)',
    description:
      'Ne pare rău, nu poți comanda încă. {{name}} a stabilit o comandă minimă de {{threshold}} (excl. costurile de livrare)',
  },
  max: {
    title: 'Valoarea maximă a comenzii pentru livrare atinsă (Total excl. costuri livrare)',
    description:
      'Comanda ta a atins valoarea maximă permisă de {{threshold}} pentru livrare online. Pentru comenzi care depășesc această sumă, contactează-ne direct și vom organiza livrarea. Mulțumim pentru înțelegere!',
  },
};
